import template from './filterHeader.jade';
import EventEmitter from '../../services/eventEmitter';

export class FilterHeaderController {
  /* @ngInject */
  constructor($rootScope) {
    this.$rootScope = $rootScope;
    this.events = this.events || new EventEmitter();
  };

  openFilterWidget() {
    this.$rootScope.$broadcast('openFilterWidget', '');
  };

  removeFilter(key) {
    delete this.searchParams[key];
  };
};

export function FilterHeaderComponent() {
  return {
    template,
    controller: FilterHeaderController,
    restrict: 'E',
    replace: true,
    bindToController: true,
    controllerAs: 'vm',
    scope: {
      searchParams: '=',
      customFieldConfigs: '=',
      disabled: '=?'
    }
  };
}

export default angular.module('app.common.filterheader', [])
  .directive('filterHeader', FilterHeaderComponent);



/** WEBPACK FOOTER **
 ** ./src/common/filter/filterHeader.js
 **/